import { editJobPostClient } from "@Services/home";
import Styles from "./styles.module.scss";
import moment from "moment";
import "moment/locale/id"; // import locale Bahasa Indonesia
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function JobActionsModal({
  handleClose = () => {},
  data = null,
  setTrigger = () => {},
  setSuccess = () => {},
  isDetail = false,
}) {
  const getNextMonthDate = () => {
    moment.locale("id"); // set locale ke Indonesia
    return moment().add(1, "months").format("DD MMMM YYYY");
  };

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    try {
      setLoading(true);

      await editJobPostClient(data?.data?.id, {
        status: data?.type === "Hapus Loker" ? "Delete" : "Unpublish",
      });

      setLoading(false);
      setError("");
      handleClose();

      if (isDetail) {
        navigate(`/business/dashboard/job-list`);
      } else {
        setSuccess(
          data?.type === "Hapus Loker"
            ? "Lowongan kerja berhasil dihapus"
            : "Lowongan kerja berhasil ditutup"
        );
        setTrigger(Math.random());
      }
    } catch (error) {
      console.log(error);
      setSuccess("");
      setLoading(false);
      setError(error.response?.data?.error);
    }
  };

  return (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <span>
          {data?.type === "Perpanjang" ? "Perpanjang Masa Aktif" : data?.type}
        </span>
      </div>

      <div className={Styles.content}>
        {data?.type === "Perpanjang"
          ? `Masa aktif lowongan kerja ${
              data?.data?.name || "-"
            } akan diperpanjang hinggal 1 bulan kedepan (${getNextMonthDate()})`
          : `Apakah kamu yakin ingin ${
              data?.type === "Hapus Loker" ? "menghapus loker" : "menutup loker"
            } ini sekarang`}{" "}
        ?
      </div>

      <div className={Styles.buttonWrapper}>
        {/* <span>*error</span> */}
        {error && <span>*{error}</span>}
        <div>
          <button disabled={loading} onClick={handleClose}>
            Batal
          </button>
          <button disabled={loading} onClick={handleSubmit}>
            {loading ? "loading..." : `Ya, ${data?.type}`}
          </button>
        </div>
      </div>
    </div>
  );
}
